<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-5"><a href="#/High_Stakes2#Contents-A">Acknowledgments</a></p>
<p class="fp">My thanks to faithful sources of encouragement Frier C. McCollister, Kirk Borland, the Tilton family, Joe Hoy, and Gwen Macsai; to William M. Sheridan and Eoin Purcell for valuable advice; and to editor Barbara Peters and the dedicated staff at Poisoned Pen Press for their continued expertise.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// High_Stakes-4.vue?2b7c6e18